import { useQuery } from '@tanstack/react-query';

import { paymentsQueryKeys } from '../payments-qk';
import { PaymentsApi } from '../payments.api';
import { IGetPaymentsHistoryParams, IGetPaymentsHistoryResponse } from '../types';

export const useGetPaymentsHistory = (params: IGetPaymentsHistoryParams = {}) => {
  return useQuery<IGetPaymentsHistoryResponse>({
    queryKey: paymentsQueryKeys.paymentsList(params),
    queryFn: () => {
      if (params.delay) {
        return new Promise<IGetPaymentsHistoryResponse>((resolve) => {
          setTimeout(async () => {
            const newParams = {
              page: params.page,
              size: params.size,
              sort: params.sort,
            };
            const result = await PaymentsApi.getPaymentsHistory(newParams);
            resolve(result);
          }, params.delay);
        });
      }
      return PaymentsApi.getPaymentsHistory(params);
    },
  });
};
